// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"cbac829c","140":"5449a013","404":"6a052c94","664":"633476a7","693":"4166db7e","915":"72863bd2"}[chunkId] + ".chunk.js";
};